<script>
	// Custom line mark for the Legends of Tasmania experience grid. Drawn to the
	// same geometry as the lucide set used elsewhere (24px box, 1.5 stroke,
	// round caps) so it sits naturally beside them.
	let { class: className = '' } = $props();
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 24"
	fill="none"
	stroke="currentColor"
	stroke-width="1.5"
	stroke-linecap="round"
	stroke-linejoin="round"
	class={className}
	aria-hidden="true"
>
	<circle cx="12" cy="8.6" r="4.6" />
	<circle cx="10.4" cy="7.6" r=".55" fill="currentColor" stroke="none" />
	<circle cx="13.5" cy="7.5" r=".55" fill="currentColor" stroke="none" />
	<circle cx="12" cy="10.5" r=".55" fill="currentColor" stroke="none" />
	<path d="M10.3 14.1h3.4" />
	<path d="M12 14.1v4.4" />
	<path d="M7 18.5h10" />
</svg>
